/******** search.js ********/

function doSearch(): void {
  var searchString = "";
  try {
    searchString = (<HTMLFormElement>document.getElementById('OCForm1')).searchUI_tbProductName
      .value;
  } catch (e) { }
  try {
    searchString = searchString.replace("(", "").replace(")", "");
  } catch (e) { }
  if (searchString !== "" && searchString !== "I'm looking for...") {
    window.location.href =
      "search.aspx?&posting=TRUE&actionType=CUSTOMSEARCH&customSearchParams=KEYWORDS|" +
      encodeURIComponent(searchString) +
      "&customSearchParamsSearchString=" +
      encodeURIComponent(searchString) +
      "&from=QUICKSEARCH";
  } else {
    alert("Enter a search term");
  }
}

function doQuickSearch(searchPath: string): void {
  var searchString = "";
  try {
    searchString = (<HTMLFormElement>document.getElementById('OCForm1')).tSearchString.value;
  } catch (e) { }
  try {
    searchString = searchString
      .replace("(", "")
      .replace(")", "")
      .replace("'", "");
  } catch (e) { }
  if (searchString !== "") {
    window.location.href =
      searchPath +
      "search.aspx?&posting=TRUE&actionType=CUSTOMSEARCH&customSearchParams=KEYWORDS|" +
      encodeURIComponent(searchString) +
      "&customSearchParamsSearchString=" +
      encodeURIComponent(searchString) +
      "&from=QUICKSEARCH";
  } else {
    alert("Please enter a keyword");
  }
}